// extracted by mini-css-extract-plugin
module.exports = {"root":"Page404_root__3bbEg"};